module.exports = __webpack_public_path__ + "static/media/App.9ae58721.png";